import { graphql, useStaticQuery } from "gatsby"

export interface ConferenceImage {
  name: string;
  srcSet: string[];
  alt: string;
  fluid: {};
  href: string;
}

const conferenceLinks = {
  'greentech': 'https://www.greentech.nl/amsterdam/exhibition-info/greentech-amsterdam/',
  'icbc': 'https://internationalcbc.com/berlin/',
  'cb-expo':'https://www.cb-net.ch/de/cb_expo',
}

export const useConferenceImages: (page?: string) => ConferenceImage[] = () => {
  const { allFile, site } = useStaticQuery(
    graphql`
        query ConferenceImages {
            allFile(filter: {relativeDirectory: {eq: "conferences"}}) {
                nodes {
                    childImageSharp {
                        fluid(jpegQuality: 80, pngQuality: 80) {
                            srcSet
                            originalName
                            ...GatsbyImageSharpFluid
                        }
                    }
                }
            }
            site {
                siteMetadata {
                    title
                }
            }
        }
    `
  )

  return allFile.nodes.map(node => (
    {
      name: node.childImageSharp.fluid.originalName.split(".")[0],
      srcSet: node.childImageSharp.fluid.srcSet,
      href: conferenceLinks[node.childImageSharp.fluid.originalName.split(".")[0]],
      fluid: node.childImageSharp.fluid,
      alt: `${site.siteMetadata.title} ${node.childImageSharp.fluid.originalName.split(".")[0]} image`
    } as ConferenceImage)
  )
}
